import { render, staticRenderFns } from "./DashboardFeedbackByCategory.vue?vue&type=template&id=34f781af&scoped=true&"
import script from "./DashboardFeedbackByCategory.vue?vue&type=script&lang=js&"
export * from "./DashboardFeedbackByCategory.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFeedbackByCategory.vue?vue&type=style&index=0&id=34f781af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f781af",
  null
  
)

export default component.exports